module.exports = __webpack_public_path__ + "3ba881ae8f5c391072f2036ba0eaaaad.pdf";